<template>
  <el-upload
    action=""
    :multiple="false"
    :limit="1"
    :auto-upload="false"
    :on-change="submitUpload"
    :on-remove="handleRemove"
    :file-list="fileList"
    @click.native="onAttach"
  >
    <el-button
      slot="trigger"
      size="small"
      type="primary"
      :disabled="!!fileList.length"
      >Выберите файл</el-button
    >
  </el-upload>
</template>

<script>
export default {
  props: {
    value: {
      type: [File, Array],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  computed: {
    uploadValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (val && val.length) {
          val = val[0].raw;
        }

        this.$emit("input", val);
      },
    },
  },
  watch: {
    // если форму сбросили, удаляем прикрепленные файлы
    value(newVal) {
      if (!newVal) {
        this.fileList = [];
      }
    },
  },
  methods: {
    submitUpload(file, fileList) {
      this.fileList = fileList;
      this.uploadValue = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.uploadValue = fileList;
    },
    onAttach(e) {
      if (this.fileList.length) {
        e.preventDefault();
      }
    },
  },
};
</script>
